function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "55",
  height: "57",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#6F777B",
  d: "M33.667 57l8.192-8.192L23 30.036V0h6.997v26.964L46.808 43.86 55 35.668V57z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BFC1C3",
  d: "M20.91 57H0V36.09l8.03 8.03L18.15 34 23 38.85 12.88 48.97z"
}))));